import { defineComponent as _defineComponent } from 'vue'
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import { useRoute } from "vue-router/composables";
import { computed, onBeforeMount, ref } from "vue";
import BaseStatus from "@/components-UI/BaseStatus.vue";
import { IStatus } from "@/types";
import { getBillSingle } from "@/api/payout";
import { Bill } from "@/api/types/payout";
import { showServerError } from "@/utils";
import { BillCards, useBillSingle } from "@/services/TablePage/bills";
import BaseListV2 from "@/components-UI/list/BaseListV2.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BillSingle',
  setup(__props) {

const route = useRoute();
const isLoading = ref(true);
const bill = ref<Bill | null>(null);
const status = ref<IStatus | null>(null);
const title = computed(() => `Платеж ${route.params.id}`);
const cards = ref<BillCards | null>(null);

onBeforeMount(() => {
    getBill();
    document.title = title.value;
});

const getBill = async () => {
    try {
        bill.value = await getBillSingle(route.params.id);
        status.value = bill.value?.is_paid
            ? { text: 'Оплачен', color: 'green' }
            : { text: 'Не оплачен', color: 'red' };
        const { getCards } = useBillSingle(bill.value);
        cards.value = getCards();
    } catch (error) {
        showServerError(error, 'Платеж не найден');
    } finally {
        isLoading.value = false;
    }
};


return { __sfc: true,route, isLoading, bill, status, title, cards, getBill, PageLayout, BaseStatus, BaseListV2, BaseEditableCard }
}

})